module.exports = __webpack_public_path__ + "static/media/ProfessionalValue.58a88957.svg";